import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Col, Grid, Row } from 'react-flexbox-grid/dist/react-flexbox-grid';
import Layout from '../../../App/components/Layout/LayoutContainer';
import Spinner from '../../../App/components/Spinner/Spinner';

function CheckoutPage({ hostedPage }) {
  useEffect(() => {
    if (hostedPage?.url) {
      window.location.href = hostedPage.url;
    }
  }, [hostedPage]);

  return (
    <Layout>
      <Grid style={{ width: '100%', padding: '20px 0', background: '#fafaf9' }} fluid>
        <Row>
          <Col xs={12} sm={12}>
            <div id="checkout-info">
              <Spinner />
            </div>
          </Col>
        </Row>
      </Grid>
    </Layout>
  );
}

CheckoutPage.defaultProps = {
  hostedPage: null,
};

CheckoutPage.propTypes = {
  hostedPage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    id: PropTypes.string,
  }),
};

export default CheckoutPage;
